<template>
    <div :class="`improvement-filter improvement-filter--${this.filterKey}`">
        <div class="improvement-filter__icon-wrapper">
            <div :id="`${this.filterKey}-checkbox`"
                 :class="`improvement-filter__icon improvement-filter__icon--${this.filterKey}${this.value ? ' improvement-filter__icon--active' : ''}`"
                 role="checkbox"
                 :aria-checked="ariaChecked"
                 :aria-labelledby="`${this.filterKey}-label`"
                 tabindex="0"
                 @keyup.enter="$emit('input', !value)"
                 @keyup.space="$emit('input', !value)"
                 @keyup.esc="$emit('keyup.esc')"
                 @click="$emit('input', !value)">
                <i v-if="value" :class="activeIcon" />
                <i v-else :class="altIcon" />
            </div>
        </div>
        <div :id="`${this.filterKey}-label`"
             class="improvement-filter__text">
            {{ stateText }} <span v-if="filterText">{{ filterText }} </span><slot />
        </div>
    </div>
</template>

<script>

export default {

    props: {

        /**
         * @type {string|{}}
         */
        activeIcon: {
            type: String,
            required: true,
        },

        /**
         * @type {string|{}}
         */
        filterKey: {
            type: String,
            required: true,
        },

        /**
         * @type {boolean|{}}
         */
        value: {
            type: Boolean,
            default: false,
        },

        /**
         * @type {string|{}}
         */
        filterText: {
            type: String,
            default: '',
        },

        /**
         * @type {?string|{}}
         */
        inactiveIcon: {
            type: String,
            default: null,
        },
    },

    computed: {

        altIcon() {
            return this.inactiveIcon ? this.inactiveIcon : this.activeIcon
        },

        ariaChecked() {
            return this.value ? 'true' : 'false'
        },

        stateText() {
            return this.value ? 'filtered to' : 'filter to'
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_improvement-filter.scss

$icon-area-side-px: 36px;
$icon-area-side: rem($icon-area-side-px);

.improvement-filter {
    @include user-select-none;
    height: $icon-area-side;
    display: table;

    > * {
        display: table-cell;
        vertical-align: middle;
    }

    a {
        font-weight: bold;
    }

    @include element('icon') {
        cursor: pointer;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        font-size: 1.3rem;
        height: $icon-area-side;
        width: $icon-area-side;
        min-height: $icon-area-side;
        min-width: $icon-area-side;
    }

    @include element('text') {
        padding: 0 1rem;
        display: table-cell;
    }
}

</style>
